import React from 'react';
import TypeControlledTextField from '../../../tc-ui/type-controlled-textfield.jsx';
import TwoColumnRow from '../../../tc-ui/two-column-row';
import RateTypeForm from './RateType';
import { currencies, taxTypes } from '../../../../utils/select-fields';
import Select from 'react-select';

const Rates = ({
  showTaxCurrency,
  updateFieldValue,
  updateFormData,
  locationId,
  productId,
  ...fieldValues }) => {
  const {
    taxInclusion,
    rateType,
    commissionPercentage,
    baseRate,
    retailRate,
    taxType,
    currency,
    additionalChild,
    additionalChildRetail,
    additionalAdult,
    additionalAdultRetail,
    includedGuestsinBaseRate,
    includedGuestsError,
    maxAdultsChildren,
    maxAdults,
    maxGuestsError,
    maxAdultsError,
  } = fieldValues;
  const fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
  const leftColumnStyle = { width: '40%', textAlign: 'left', fontSize: '15px', fontFamily };
  const rightColumnStyle = { width: '60%', textAlign: 'left', paddingRight: '6%', fontFamily };
  return (
    <div>
      <TwoColumnRow
        outerContainerStyle={{ marginBottom: '0' }}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        leftColumnContent={
          <div>
            Rate type
            <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * Required
            </div>
          </div>
        }
        rightColumnContent={
          <RateTypeForm
            rateType={rateType}
            commissionPercentage={commissionPercentage}
            nettCommission={fieldValues.nettCommission}
            updateRateType={(value) => updateFormData({ fieldName: 'rateType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId)}
            updateCommission={(value) => updateFormData({ fieldName: 'commissionPercentage', value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId)}
            updateNettCommission={(value) => updateFormData({ fieldName: 'nettCommission', value }, 'UPDATE_ADD_RATES_FIELD', 'location', locationId, productId)}
          />
        }
      />
      <TwoColumnRow
        hide={!showTaxCurrency}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ marginBottom: '', overflow: '' }}
        leftColumnContent={
          <div>
            Tax information
            <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * Required
            </div>
          </div>
        }
        rightColumnContent={
          <div>
            <div style={{ width: '40%', display: 'inline-block' }}>
              <Select
                name="taxInclusion"
                options={[
                  { value: 'inclusive', label: 'Tax inclusive' },
                  { value: 'exclusive', label: 'Tax exclusive' },
                  { value: 'exempt', label: 'Tax exempt' },
                ]}
                value={taxInclusion}
                onChange={({ value }) => updateFormData({ fieldName: 'taxInclusion', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location')}
                placeholder="Tax Inclusion"
                clearable={false}
                scrollMenuIntoView={false}
              />
            </div>
            {
            taxInclusion !== 'exempt' ?
            <div style={{ width: '50%', marginLeft: '5%', display: 'inline-block' }}>
              <Select
                name="taxType"
                options={taxTypes}
                value={taxType}
                onChange={({ value }) => updateFormData({ fieldName: 'taxType', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location')}
                placeholder="Tax Type"
                clearable={false}
                scrollMenuIntoView={false}
              />
            </div> : undefined
            }
          </div>
        }
      />
      <TwoColumnRow
        hide={!showTaxCurrency}
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', clear: 'both', height: '42px', marginBottom: '0' }}
        leftColumnContent={<div style={{ marginTop: '12px' }}>
            Currency
          <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
            * Required
          </div>
        </div>}
        rightColumnContent={
          <div style={{ width: '135px', position: 'relative', top: '10px', display: 'inline-block' }}>
            <Select
              name="currency"
              options={currencies}
              value={currency}
              onChange={({ value }) => updateFormData({ fieldName: 'currency', value: value.trim() }, 'UPDATE_ADD_RATES_FIELD', 'location')}
              placeholder="Currency"
              clearable={false}
              scrollMenuIntoView={false}
            />
          </div>
        }
      />
      <TwoColumnRow
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflow: 'inherit', marginBottom: '0', clear: 'both' }}
        leftColumnContent={
          <div style={{ marginTop: '20px' }}>
            Base rates information
            <div style={{ color: '#999', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * Please enter your base room rates.
            </div>
            <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * All fields are required
            </div>
          </div>
        }
        rightColumnContent={
          <TwoColumnRow
            outerContainerStyle={{ overflow: 'inherit', marginBottom: '0' }}
            leftColumnStyle={{ display: rateType === 'nett' ? 'none' : 'inline-block', width: rateType === 'nett' ? '0' : '60%' }}
            rightColumnStyle={{ float: rateType === 'includeCommission' ? 'right' : '', width: rateType === 'nett' ? '100%' : '40%', display: 'inline-block' }}
            leftColumnContent={
              <div>
              <span style={{ width: '40%', display: rateType === 'includeCommission' ? 'inline-block' : 'none' }}>Base rate</span>
                <TypeControlledTextField
                  id="base-nett"
                  controlledType="number"
                  style={{ width: '50%', marginLeft: '1%', marginBottom: '12px' }}
                  hintStyle={{ fontSize: '12px' }}
                  inputStyle={{ fontSize: '14px' }}
                  hintText="Enter retail rate here"
                  value={retailRate}
                  onChange={({ target: { value } }) => updateFieldValue({ fieldName: 'retailRate', value })}
                />
                <br />
                <span style={{ width: '40%', display: rateType === 'includeCommission' ? 'inline-block' : 'none' }}>Extra adult</span>
                <TypeControlledTextField
                  controlledType="number"
                  style={{ width: '50%', marginLeft: '1%', marginBottom: '12px' }}
                  hintStyle={{ fontSize: '12px' }}
                  inputStyle={{ fontSize: '14px' }}
                  hintText="Enter retail rate here"
                  value={additionalAdultRetail}
                  onChange={({ target: { value } }) => updateFormData({ fieldName: 'additionalAdultRetail', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
                />
                <br />
                <span style={{ width: '40%', display: rateType === 'includeCommission' ? 'inline-block' : 'none' }}>Extra child</span>
                <TypeControlledTextField
                  controlledType="number"
                  style={{ width: '50%', marginLeft: '1%', marginBottom: '12px' }}
                  hintStyle={{ fontSize: '12px' }}
                  inputStyle={{ fontSize: '14px' }}
                  hintText="Enter retail rate here"
                  value={additionalChildRetail}
                  onChange={({ target: { value } }) => updateFormData({ fieldName: 'additionalChildRetail', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
                />
              </div>
            }
            rightColumnContent={
              <div style={{ width: '100%' }}>
                <span style={{ width: '24%', display: rateType === 'nett' ? 'inline-block' : 'none' }}>Base rate</span>
                <TypeControlledTextField
                  controlledType="number"
                  style={{ width: '75%', marginBottom: '12px' }}
                  hintStyle={{ fontSize: '12px', zIndex: '0' }}
                  inputStyle={{ fontSize: '14px' }}
                  disabled={rateType === 'includeCommission'}
                  hintText={rateType === 'includeCommission' ? 'Auto calculated' : 'Enter nett rate here'}
                  value={baseRate}
                  onChange={({ target: { value } }) => updateFieldValue({ fieldName: 'baseRate', value })}
                />
                <br />
                <span style={{ width: '24%', display: rateType === 'nett' ? 'inline-block' : 'none' }}>Extra adult</span>
                <TypeControlledTextField
                  controlledType="number"
                  style={{ width: '75%', marginBottom: '12px' }}
                  hintStyle={{ fontSize: '12px' }}
                  inputStyle={{ fontSize: '14px' }}
                  disabled={rateType === 'includeCommission'}
                  hintText={rateType === 'includeCommission' ? 'Auto calculated' : 'Enter nett rate here'}
                  value={additionalAdult}
                  onChange={({ target: { value } }) => updateFormData({ fieldName: 'additionalAdult', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
                />
                <br />
                <span style={{ width: '24%', display: rateType === 'nett' ? 'inline-block' : 'none' }}>Extra child</span>
                <TypeControlledTextField
                  controlledType="number"
                  style={{ width: '75%', marginBottom: '12px' }}
                  hintStyle={{ fontSize: '12px' }}
                  inputStyle={{ fontSize: '14px' }}
                  disabled={rateType === 'includeCommission'}
                  hintText={rateType === 'includeCommission' ? 'Auto calculated' : 'Enter nett rate here'}
                  value={additionalChild}
                  onChange={({ target: { value } }) => updateFormData({ fieldName: 'additionalChild', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
                />
              </div>
            }
          />
        }
      />
      <TwoColumnRow
        leftColumnStyle={leftColumnStyle}
        rightColumnStyle={rightColumnStyle}
        outerContainerStyle={{ overflowY: 'hidden', clear: 'both' }}
        leftColumnContent={
          <div style={{ marginTop: '42px' }}>
            Room occupancy
            <div style={{ color: '#999', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * Please enter the number of guests included in the base rate, as well as the maximum number of guests the room can hold.
            </div>
            <div style={{ color: 'red', fontSize: '12px', fontWeight: '400', width: '200px' }}>
              * All fields are required
            </div>
          </div>}
        rightColumnContent={
          <div>
            <TypeControlledTextField
              controlledType="number"
              style={{ display: 'block', width: '85%' }}
              hintStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              inputStyle={{ fontSize: '14px' }}
              hintText="Whole number only"
              floatingLabelText="Included guests in base rate"
              value={includedGuestsinBaseRate}
              errorText={includedGuestsError}
              onChange={({ target: { value } }) => updateFormData({ fieldName: 'includedGuestsinBaseRate', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
            />
            <TypeControlledTextField
              controlledType="number"
              style={{ display: 'block', width: '85%' }}
              hintStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              inputStyle={{ fontSize: '14px' }}
              hintText="Whole number only"
              floatingLabelText="Maximum adults"
              value={maxAdults}
              errorText={maxAdultsError}
              onChange={({ target: { value } }) => updateFormData({ fieldName: 'maxAdults', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
            />
            <TypeControlledTextField
              controlledType="number"
              style={{ display: 'block', width: '85%' }}
              hintStyle={{ fontSize: '14px' }}
              floatingLabelShrinkStyle={{ color: 'rgba(0, 0, 0, 0.64)' }}
              inputStyle={{ fontSize: '14px' }}
              hintText="Whole number only"
              floatingLabelText="Max Occupancy (Adults + Children)"
              value={maxAdultsChildren}
              errorText={maxGuestsError}
              onChange={({ target: { value } }) => updateFormData({ fieldName: 'maxAdultsChildren', value }, 'UPDATE_ADD_RATES_FIELD', 'accomProduct', locationId, productId)}
            />
          </div>
        }
      />
    </div>);
};


export default Rates;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/rate-forms/accom-rates-form.jsx